import { render, staticRenderFns } from "./type13.vue?vue&type=template&id=25114cec&scoped=true&"
import script from "./type13.vue?vue&type=script&lang=js&"
export * from "./type13.vue?vue&type=script&lang=js&"
import style0 from "./type13.vue?vue&type=style&index=0&id=25114cec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25114cec",
  null
  
)

export default component.exports